module.exports = __webpack_public_path__ + "static/media/gray-loading-icon-16x16.f92ba4e1.svg";